"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFalsy = exports.isTruthy = void 0;
const falsyValues = [undefined, null, false, 0, '', 'false'];
const isTruthy = (input) => {
    if (falsyValues.includes(input)) {
        return false;
    }
    return true;
};
exports.isTruthy = isTruthy;
const isFalsy = (input) => {
    if (falsyValues.includes(input)) {
        return true;
    }
    return false;
};
exports.isFalsy = isFalsy;
